import { createMemo, createSignal, onCleanup, onMount } from 'solid-js';

const pad = (n: number) => String(n).padStart(2, '0');

/** UTC HH:MM:SS string, ticking once per second.
 *  Returned as a memo accessor so the caller subscribes normally
 *  (e.g. `<span>{clock()}</span>`). */
export function createClock() {
  const [now, setNow] = createSignal(new Date());
  onMount(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    onCleanup(() => clearInterval(id));
  });
  const formatted = createMemo(() => {
    const t = now();
    return `${pad(t.getUTCHours())}:${pad(t.getUTCMinutes())}:${pad(t.getUTCSeconds())}`;
  });
  return formatted;
}

/** A counter that increments at a fixed cadence — useful for ambient telemetry. */
export function createTicker(intervalMs: number) {
  const [tick, setTick] = createSignal(0);
  onMount(() => {
    const id = setInterval(() => setTick((t) => t + 1), intervalMs);
    onCleanup(() => clearInterval(id));
  });
  return tick;
}
